import { render, staticRenderFns } from "./FAQPage.vue?vue&type=template&id=7f20b65b&"
import script from "./FAQPage.vue?vue&type=script&lang=js&"
export * from "./FAQPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports